import React from 'react';
import { Car, ShoppingBag, FileText, CreditCard, CheckCircle } from 'lucide-react';

const steps = [
  { id: 1, label: 'Vehicle', icon: Car },
  { id: 2, label: 'Extras', icon: ShoppingBag },
  { id: 3, label: 'Details', icon: FileText },
  { id: 4, label: 'Payment', icon: CreditCard },
  { id: 5, label: 'Confirm', icon: CheckCircle },
];

const BookingStepper = ({ currentStep = 1 }) => {
  return (
    <div className="w-full bg-white rounded-xl p-4 mb-6" data-testid="booking-stepper">
      <div className="flex items-center justify-between max-w-3xl mx-auto">
        {steps.map((step, index) => {
          const Icon = step.icon;
          const isActive = step.id === currentStep;
          const isCompleted = step.id < currentStep;
          const isLast = index === steps.length - 1;

          return (
            <React.Fragment key={step.id}>
              {/* Step */}
              <div className="flex flex-col items-center relative" data-testid={`step-${step.id}`}>
                {/* Icon Circle */}
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 ${
                    isActive
                      ? 'bg-[#FF8C00] text-white'
                      : isCompleted
                        ? 'bg-[#FF8C00]/20 text-[#FF8C00]'
                        : 'bg-gray-100 text-gray-400'
                  }`}
                >
                  <Icon className="h-5 w-5" />
                </div>

                {/* Label */}
                <span
                  className={`mt-2 text-xs font-medium transition-colors ${
                    isActive
                      ? 'text-[#FF8C00]'
                      : isCompleted
                        ? 'text-black'
                        : 'text-gray-400'
                  }`}
                >
                  {step.label}
                </span>

                {/* Active Lane Line */}
                {isActive && (
                  <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-[#FF8C00] rounded-full animate-pulse" />
                )}
              </div>

              {/* Connector Line (Road Lane Motif) */}
              {!isLast && (
                <div className="flex-1 mx-2 relative h-0.5">
                  {/* Background dashed line */}
                  <div className="absolute inset-0 border-t-2 border-dashed border-gray-200" />
                  {/* Active/Completed solid line */}
                  {(isCompleted || isActive) && (
                    <div
                      className={`absolute top-0 left-0 h-0.5 bg-[#FF8C00] transition-all duration-500 ${
                        isCompleted ? 'w-full' : 'w-0'
                      }`}
                    />
                  )}
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default BookingStepper;
